export const testimonials = [
  {
    id: 1,
    name: 'María González',
    text: 'Incredible experience in Torres del Paine. GaLi Travel organized every detail to perfection. The guides were exceptional and the landscapes simply unforgettable. I will definitely travel with them again.',
    rating: 5,
    avatar: 'https://public.readdy.ai/ai/img_res/5cb335c63f75959664b517e027d5835e.jpg',
  },
  {
    id: 2,
    name: 'Carlos Ramírez',
    text: 'The tour through the Atacama desert exceeded all my expectations. The personalized attention and the places visited were spectacular. GaLi Travel really knows how to make a trip memorable.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20cheerful%20Chilean%20man%20in%20his%20forties%20with%20genuine%20smile%20and%20confident%20expression%20against%20neutral%20background%20showcasing%20happy%20travel%20client%20with%20natural%20lighting%20and%20trustworthy%20appearance&width=200&height=200&seq=avatar-carlos&orientation=squarish',
  },
  {
    id: 3,
    name: 'Sofía Morales',
    text: 'I traveled to Easter Island with my family and it was a magical experience. Everything was perfectly coordinated, from the flights to the excursions. The GaLi Travel team is professional and very friendly.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20Chilean%20woman%20in%20her%20twenties%20with%20bright%20smile%20and%20enthusiastic%20expression%20against%20neutral%20background%20showcasing%20delighted%20travel%20customer%20with%20natural%20lighting%20and%20positive%20energy&width=200&height=200&seq=avatar-sofia&orientation=squarish',
  },
];
